import type { DynamicTag } from "@/api/useWorkflow.types"

export const SLACK_MESSAGE_MAX_LENGTH = 10000

const TAG = /\{\{\s*([a-z0-9_]+)\s*\}\}/gi

const MARKDOWN_LINK = /\[([^\]]+)\]\([^)]*\)/g

// Link tags render as links in Slack; the preview only needs their text.
const exampleOf = ({ example, valueType }: DynamicTag) => {
  const text = example.replace(MARKDOWN_LINK, "$1")
  return valueType === "link" && text ? `<https://example.com|${text}>` : text
}

export const fillTagExamples = (template: string, tags: DynamicTag[]) => {
  const examples = new Map(tags.map((tag) => [tag.key, exampleOf(tag)]))
  return template.replace(TAG, (match, key: string) =>
    examples.has(key) ? examples.get(key) || "" : match
  )
}

export const insertTag = (
  text: string,
  key: string,
  selectionStart = text.length,
  selectionEnd = selectionStart
) => {
  const tag = `{{${key}}}`
  return {
    text: text.slice(0, selectionStart) + tag + text.slice(selectionEnd),
    cursor: selectionStart + tag.length
  }
}
